<template>
    <div id="nav">
        <router-link to="/">
            <span class="iconfont icon-shouye1"/>
            <p>首页</p>
        </router-link>
        <router-link to="/goods/category">
            <span class="iconfont icon-fenlei1"/>
            <p>分类</p>
        </router-link>
        <router-link to="/order/cart" class="cart">
            <div class="cart-child">
                <div class="iconfont icon-gouwuche1"></div>
                <div class="cart-total-num" v-if="cart_total_num>0">{{cart_total_num}}</div>
                <p>购物车</p>
            </div>
        </router-link>
        <router-link to="/member">
            <span class="iconfont icon-wode2"/>
            <p>我的</p>
        </router-link>
    </div>
</template>
<script>
export default {
    name: 'Tabber',

    data: function () {
        return {
            counter: 0,
            cart_total_num: this.GLOBAL.cart_total_num, // 购物车商品总数量
        }
    },
    created() {
        // 获取购物车数量
        this.setTabBarBadge();
    },
    mounted() {
        if (this.cart_total_num <= 0) {
            this.cartNum();
        }
    },
    methods: {
        cartNum() {
            let _this = this;
            _this._get('wxapp/cartNum', {}, res => {
                _this.cart_total_num = res.total_num;
            })
        },

        update(num) {
            let _this = this;
            _this.cart_total_num = num;
        },
    }
}
</script>
<style lang="scss">
#nav {
    width: 100%;
    padding: 5px 0;
    max-width: 750px;
    background: $white;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 50%;
    @include tlate(-50%, 0);
    z-index: 9990;
    @include shadow();

    .iconfont {
        font-size: 20px;
        position: relative;
        z-index: -1;
    }

    .cart {
        display: flex;
        justify-content: center;

        .cart-child {
            width: 60px;

            .cart-total-num {
                background: rgba(255, 86, 86, 1);
                width: 20px;
                height: 20px;
                border-radius: 60px;
                float: right;
                color: #fff;
                text-align: center;
                line-height: 20px;
                margin-top: -25px;
                margin-right: 5px;
                z-index: 99;
            }
        }

    }

    a {
        float: left;
        width: 25%;
        font-size: 12px;
        color: $color-90;

        &.router-link-exact-active {
            color: $main-color;

            p {
                color: $main-color;
            }
        }
    }
}
</style>
